import { 
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text
} from '@chakra-ui/react';

import { Buttons } from './styles';
import { useAuth } from '../../../hooks/auth';

interface ModalConfirmDeleteParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
}

const ModalConfirmDelete: React.FC<ModalConfirmDeleteParams> = ({
	isOpen,
	onRequestClose,
}) => {
	const { signOutPintor10 } = useAuth();

	return (
		<Modal
			isCentered={true}
			size="lg"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />
			
			<ModalContent mx={2}>
				<ModalCloseButton />

				<ModalHeader color="red.900">Excluir Conta</ModalHeader>

				<ModalBody>
					<Text
						fontSize={20}
						fontWeight={500}
						mt={4}
						color="red.900"
					>
						Tem certeza que deseja excluir a sua conta no Pinto10?
					</Text>
				</ModalBody>

				<ModalFooter pt={["0", "2"]}>
					<Buttons>
						<button
							type="button"
							className="button-save"
							onClick={() => onRequestClose(false)}
						>
							Cancelar
						</button>

						<button
							type="submit"
							className="button-cancel"
							onClick={signOutPintor10}
						>
							Sim, excluir
						</button>
					</Buttons>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default ModalConfirmDelete;